// extracted by mini-css-extract-plugin
export var avatarContainer = "_hy-0";
export var avatarTypingWave = "_hy-i";
export var gray = "_hy-f";
export var green = "_hy-c";
export var icon = "_hy-9";
export var image = "_hy-1";
export var lg = "_hy-6";
export var md = "_hy-5";
export var presenceDot = "_hy-b";
export var red = "_hy-d";
export var sm = "_hy-4";
export var status = "_hy-a";
export var typingDot = "_hy-h";
export var typingPill = "_hy-g";
export var xl = "_hy-7";
export var xs = "_hy-3";
export var xxl = "_hy-8";
export var xxs = "_hy-2";
export var yellow = "_hy-e";